
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/energy-insights/articles/[slug]",
      function () {
        return require("private-next-pages/energy-insights/articles/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/energy-insights/articles/[slug]"])
      });
    }
  